import { TableCell as MuiTableCell, styled } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
export const TableCellStyled = styled(MuiTableCell, shouldNotForwardProps('primary', 'medium', 'maxWidth', 'fixedWidth', 'fitContent', 'stretch', 'noWrap'))(({ theme, primary, medium, maxWidth, fixedWidth, fitContent, stretch, noWrap }) => ({
    ...(primary && { color: theme.palette.text.primary }),
    ...(medium && { fontWeight: theme.typography.fontWeightMedium }),
    ...(maxWidth && { maxWidth }),
    ...(fixedWidth && { width: fixedWidth, maxWidth: fixedWidth }),
    ...(fitContent && { width: '1%' }),
    ...(stretch && { width: 'auto' }),
    ...(noWrap && { whiteSpace: 'nowrap' }),
}));
